package views.coletor

import androidx.compose.runtime.*
import ffButton0
import ffButtonDiv
import kotlinx.browser.document
import kotlinx.dom.clear
import lbTitulo
import model.*
import ffMsgAviso
import ffSpan
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.renderComposable
import org.w3c.dom.HTMLDivElement
import org.w3c.dom.HTMLInputElement
import utils.*
import utils.ff.Companion.println0
import views.componentes.*

class col006 {

    private val _t = "col006" //inventário
    private var linvIte: List<InventarioIte>? = null
    private var oinvIte: InventarioIte? = null
    private var oinv: Inventario? = null

    fun show() {

        lbTitulo!!.innerText = "006 - Inventário"
        //prepare()

        val htmlDiv1 = document.getElementById("htmlDiv1") as HTMLDivElement
        htmlDiv1.clear()

        renderComposable(rootElementId = "htmlDiv1") {
            body()
        }
    }

    @Composable
    fun body() {


        val _tela = remember { mutableStateOf("codigo") }
        val _inventario = remember { mutableStateOf(gsInput(_t)) }
        val _table1Controler = remember { mutableStateOf(gsInput(_t)) }

        val _btAbrir = remember { mutableStateOf(gsInput(_t)) }

        //ffMsgAviso("")

        //ffInput1("Número do inventário", _inventario, "NS", 999999, 100, false)
        ffInput44("Número do inventário", _inventario, "NS", 0, 100, false, {}, {})
        if (_tela.value.equals("codigo")) {
            SideEffect { _inventario.setFocusSimples(true) }
        }
        _inventario.onKeyPressENTER { //a ->
            if (!_inventario.text().equals("")) { // && _table1Controler.json().equals("")) {
                println0("@investigar 1")
                _btAbrir.enabled(false)
                getInventario(_inventario.text().ffPegaId().ffVsi()) { o ->

                    //println0("@investigar 1.1, vai imprimir o")
                    //println0(o)
                    //if (!o)
                    //    println0("@investigar 2")
                    //_table1Controler.json(JSON.stringify(linvIte).ffJsonParse(false))
                    //_tela.value = "titulo"


                    if (o) {
                        println0("@investigar 3")
                        getInventarioItens(_inventario.text().ffPegaId().ffVsi(), "S") { lo ->
                            _table1Controler.json(JSON.stringify(lo).ffJsonParse(false))
                            _tela.value = "titulo"
                        }
                    }

                    _inventario.enabled(false)

                }
            }
        }

        if (_btAbrir.enabled()) {
            ffButton0("Abrir", { _btAbrir.enabled(false) }, 100)
        } else {

            if (oinv != null) {
                _inventario.text("${oinv!!.INV_CODIGO.ffZeroLeft(6)} - ${oinv!!.INV_TITULO}")
            }

            //_inventario.enabled(false)
            val _inProdutoQtd = remember { mutableStateOf(gsInput(_t, _id = "${_t}_inProdutoQtd", _textAnt = "1")) }
            val _qtde = remember { mutableStateOf(gsInput(_t)) }
            //_inProdutoQtd.textAnt("1")

            val _produto = remember { mutableStateOf(gsInput(_t)) }

            fun limparTela() {
                    //println0("Gravado de novo")
                    //println0("Vai limpar a variável")
                    _produto.enabled(true)
                    _produto.clear()
                    _produto.setFocus("true")
                    _tela.value = "titulo"

                    getInventarioItens(_inventario.text().ffPegaId().ffVsi(), "S") { lo ->
                        _table1Controler.json(JSON.stringify(lo).ffJsonParse(false))
                        _tela.value = "titulo"
                        _produto.setFocusSimples()
                    }

                    //_tela.value = "titulo"
                    //_inventario.keySet("Enter")

            }

            //ffInput1("Informe o produto a ser contado", _produto, "NS", 0, 100, false)
            Div() {
                ffInput44(
                    "Informe o produto a ser contado", _produto, "NS", 0, 100, false,
                    //ffInput44("", _produto, "S", 0, 100, false,
                    _onFocusIn = {
                        ffMsgAviso("")
                    },
                    _onFocusOut = {
                        if (!_produto.text().equals("")) {
                            val o = InventarioIte().reg(_produto.text().ffPegaId(), linvIte!!)
                            println0("zuza9999 verifica o objeto retornado produto enviado = ${_produto.text().ffPegaId()}")
                            println0(o)
                            if (o == null) {
                                ffMsgAviso("Produto não encontrado!")

                            } else {
                                _produto.text(o.INV_PRODUTO.ffZeroLeft(6) + " - " + o.OO_DESCRCOMPLETA)
                                _produto.enabled(false)

                                _inProdutoQtd.text("")
                                if (o.OO_UNIDVENDA.compareTo(1.0) > 0) {
                                    if (o.OO_TIPO.equals("C"))
                                        _inProdutoQtd.text("CAIXA COM " + o.OO_UNIDVENDA.toString() + " UNIDADES")
                                    if (o.OO_TIPO.equals("D"))
                                        _inProdutoQtd.text("DISPLAY COM " + o.OO_UNIDVENDA.toString() + " UNIDADES")
                                    _inProdutoQtd.textAnt(o.OO_UNIDVENDA.toString())
                                }
                                _qtde.span("Qtd: ${o.INV_QTD}")
                                _qtde.text("1")
                                //_qtde.setFocus()
                                _qtde.select()
                            }
                        }
                    })
            }

/*
            //78998950336464
            _produto.onKeyPressENTER {
                if (!_produto.text().equals("")) {
                    val o = InventarioIte().reg(_produto.text().ffPegaId(), linvIte!!)
                    println0("zuza9999 verifica o objeto retornado")
                    println0(o)
                    if (o == null) {
                        ffMsgAviso("Produto não encontrado!")

                    } else {
                        _produto.text(o.INV_PRODUTO.ffZeroLeft(6) + " - " + o.OO_DESCRCOMPLETA)
                        _produto.enabled(false)

                        _inProdutoQtd.text("")
                        if (o.OO_UNIDVENDA.compareTo(1.0) > 0) {
                            if (o.OO_TIPO.equals("C"))
                                _inProdutoQtd.text("CAIXA COM " + o.OO_UNIDVENDA.toString() + " UNIDADES")
                            if (o.OO_TIPO.equals("D"))
                                _inProdutoQtd.text("DISPLAY COM " + o.OO_UNIDVENDA.toString() + " UNIDADES")
                            _inProdutoQtd.textAnt(o.OO_UNIDVENDA.toString())
                        }
                        _qtde.span("Qtd: ${o.INV_QTD}")
                        _qtde.text("1")
                        _qtde.setFocus()
                        _qtde.select()
                    }
                }
            }

 */


            if (!_produto.text().equals("")) {
                Div {
                    if (!_inProdutoQtd.text().equals("") && !_produto.text().equals("")) {
                        //println0("zuza9999 vai criar o input= ${_inProdutoQtd.text()}")
                        ffInput1("", _inProdutoQtd, "NS", 0, 100, false)
                        //_inProdutoQtd.text("CAIXA COM ${_inProduto.text()}")
                        _inProdutoQtd.enabled(false)
                    } else if (_produto.equals("")) {
                        _inProdutoQtd.text("")
                    }
                }
            }

            //println0("zuza99 chegou aqui")

            Div({ classes("form-group", "input-group") }) {
                //ffInputN("Quantidade: ", _qtde, "N", 9, 45, true)
                //ffInput44("Quantidade: ", _qtde, "N", 9, 45, true, {}, {})

                ffInput1("Quantidade: ", _qtde, "N", 9, 45, _onFocusOut = {}, _onFocusIn = {}, true)
                //_qtde.text_set()
                _qtde.onKeyPressENTER {
                    //o -> gsKey = "gravar"
                    _qtde.status("gravar")
                }

                ffButtonDiv("Gravar", {
                    _qtde.status("gravar")
                    //_qtde.keySet("Enter")
                }, 30)

                ffSpan("",false,1)

                ffButtonDiv("Limpar", { limparTela() }, 20)

                //if (gsKey.equals("gravar")) {
                if (_qtde.status().equals("gravar")) {
                    _qtde.status("")
                    //gsKey = ""
                    //println0("gravado 01")
                    gravarProduto(_inventario.text().ffPegaId(), _produto, _qtde, _inProdutoQtd) { b ->
                        if (b) {
                            limparTela()
                        }
                    }
                }
            }
        }

        if (!_inventario.text().equals("")) {

            println0("@investigar ${_inventario.text()}")
            println0(linvIte)
            if (_tela.value.equals("titulo")) {

                Div() {
                    println0("101vai_imprimir o grid")
                    //println0(linv)
                    if (linvIte != null && linvIte!!.size > 0) {
                        //gsJson = _table1ClickControler.jsonLer()
                        //println0("esta formando a table de novo")
                        //println0("zuza65 " + _table1ClickControler.value)
                        val lcon = ArrayList<table1>()
                        lcon.add(table1().add(80, "S", "N", "OO_PRODUTO       ", "Produto"))
                        lcon.add(table1().add(20, "N", "N", "INV_QTD          ", "Qtd"))
                        table1().ffTable1(
                            lcon,
                            _table1Controler = _table1Controler,
                            _tbTipo = "Black"
                        )
                    }

                }
            }

        }
        //_inventario.setFocusSimples()
    }

//********************************************************************************************** funcoes e eventos

    private fun gravarProduto(
        _inventario: String,
        _produto: MutableState<String>,
        _qtde: MutableState<String>,
        _inProdutoQtd: MutableState<String>,
        cb: (Boolean) -> Unit
        //_table1Controler: MutableState<String>
    ) {
        try {
            println0("try gravarProduto99 ${_produto.text().ffPegaId()} ${_inProdutoQtd.textAnt()}")

            var dContagem = _qtde.text().ffVsdo()
            dContagem = dContagem * _inProdutoQtd.textAnt().ffVsdo()
            if (_produto.text().ffCopy(1, 6).ffVsi() != 0 && linvIte != null) {
                val iProd = _produto.text().ffCopy(1, 6).ffVsi()
                oinvIte = linvIte!!.filter({ p -> p.INV_PRODUTO == iProd }).getOrNull(0)

                if (oinvIte != null && oinvIte!!.INV_PRODUTO == iProd) {
                    //val fNovaQtd = ff.ffVsd(_produto.text()).times(oinvIte!!.ESTG_UNIDVENDA)
                    oinvIte!!.INV_QTD = dContagem
                    ffMsgAviso("")
                    Service().postGen(oinvIte!!.asDynamic(), "${ff.gsDom1}/inventario/016/item") { obj ->

                        //msgAviso("Gravado 0")
                        println0(obj)
                        if (obj.PAD_SITUAC.equals("OK")) {
                            //ffMsgAviso("Gravado")
                            //_produto.text("1")
                            //_produto.text_set()

                            //_table1Controler.atualizar()
                            //var i: Int? = null
                            //i = linvIte!!.indexOf(oinvIte)
                            //_table1Controler.deleteItem(i)
                            //linvIte = linvIte!!.filter({ p -> p.INV_PRODUTO != oinvIte!!.INV_PRODUTO }).toList() as List<InventarioIte>
                            cb(true)
                        } else {
                            ffMsgAviso("Erro!")
                            print("erro ${obj.PAD_CODIGO}")
                        }
                        _inProdutoQtd.clear()

                        _qtde.clear()
                        _qtde.text("1")
                        _qtde.span("Qtd:")
                        _inProdutoQtd.textAnt("1")
                        //prepare(_inventario)
                    }

                } else {
                    ffMsgAviso("Informe o produto!")
                    //_produto.atualizar()
                }
            }
        } catch (e: Exception) {
            ffMsgAviso("Erro! ${e.message}")
        }
    }

    fun getInventarioItens(_numero: Int, _inventariados: String, callback: (ArrayList<InventarioIte>) -> Unit) {
        InventarioIte().getInventarioItens("inventario/012/${ff.giEmpresa}/$_numero/$_inventariados") { _lista ->
            linvIte = _lista

            val linvIteCont = linvIte!!.filter({ p -> p.INV_EMPRESA != 0 && p.INV_QTD != 0.0}).toList() as List<InventarioIte>
            val linvIteNCont = linvIte!!.filter({ p -> p.INV_EMPRESA != 0 && p.INV_QTD == 0.0}).toList() as List<InventarioIte>

            println0("chegou no getInventarioItens")
            val lcon1 = ArrayList<InventarioIte>()
            //if (linvIteCont!!.get(0).INV_EMPRESA != 0) {
            if (linvIteCont.getOrNull(0) != null) {
                var iCont = 0
                for (o1 in linvIteCont) {
                    lcon1.add(o1)
                    iCont += 1
                    if (iCont > 4)
                        break;
                }
            }
            if (linvIteNCont.getOrNull(0) != null) {
                var iCont = 0
                for (o1 in linvIteNCont) {
                    lcon1.add(o1)
                    iCont += 1
                    if (iCont > 6)
                        break;
                }
            }
            //println0(_lista)

            callback(lcon1)
        }

    }

    fun getInventario(_numero: Int, callback: (Boolean) -> Unit) {

        println0("@investigar getInventario numero = $_numero")
        //Inventario().getInventario("inventario/011/${ff.giEmpresa}/${_numero}") { lo ->
        Inventario().getInventario("inventario/011/${ff.giEmpresa}/${_numero}") { lo ->

            println0(lo)
            oinv = lo.getOrNull(0)
            if (oinv == null) {
                ff.println0("@investigar 0 0000")
                ffMsgAviso("Inventário não existe")
                callback(false)
            } else if (!oinv!!.INV_DTPROCESSAMENTO.ffNull()) {
                ff.println0("@investigar 1 1111")
                ffMsgAviso("Inventário já concluído, solicite uma reabertura caso necessário.")
                callback(false)
            } else {
                ff.println0("@investigar 3 3333")
                callback(true)
            }
        }
    }


    /*
    val lcon = ArrayList<table1>()
    lcon.add(table1().add(10, "S", "N", "NOT_QTCONF       ", "Conf"))
    lcon.add(table1().add(10, "S", "N", "NOT_ENTRSEQUENCIA", "Ordem"))
    lcon.add(table1().add(60, "S", "N", "OO_CLIENTE       ", "Cliente"))
    lcon.add(table1().add(10, "N", "N", "NOT_QTVOLUMES    ", "Volumes"))
    lcon.add(table1().add(30, "N", "N", "NOT_OF           ", "OF"))
    table1().ffTable1(
        lcon,
        _table1Click = _table1Click,
        _table1Controler = _table1Controler,
        _tbBlack = true
    )
    */

}


